"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _nuiIntl = require("@concur/nui-intl");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/MiniListing.css") : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://eng.wealthfront.com/2015/06/30/implementing-netflix-redesign/
// If we want slide: http://codepen.io/dangvanthanh/pen/BsDbg
// more slide: http://jsfiddle.net/jkneb/9uRKt/
var MiniListing = function MiniListing(_ref) {
  var listing = _ref.listing,
      isLoggedIn = _ref.isLoggedIn;
  var miniImage = listing.images.miniImage,
      _listing$localized = listing.localized,
      name = _listing$localized.name,
      summary = _listing$localized.summary,
      title = _listing$localized.title,
      _listing$core = listing.core,
      isUserConnected = _listing$core.isUserConnected,
      icon = _listing$core.icon;
  return _react.default.createElement("div", {
    className: "mini-listing"
  }, _react.default.createElement("img", {
    src: icon || miniImage || 'https://www.concursolutions.com/static/images/brand/logo-SAPConcur-20171204.svg',
    className: "card-image",
    alt: "".concat(name, " icon")
  }), _react.default.createElement("div", {
    className: "card-text card-title"
  }, name), !isUserConnected ? _react.default.createElement("div", {
    className: "card-text card-headline"
  }, title) : null, isLoggedIn && isUserConnected ? _react.default.createElement("span", {
    className: "is-connected-check"
  }, _react.default.createElement("span", {
    className: "is-connected-check-details icon-check icon-size-sm"
  }), "\xA0", _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Connected"
  })) : null, _react.default.createElement("div", {
    className: "overlay"
  }, summary));
};

MiniListing.propTypes = {
  listing: _propTypes.default.object.isRequired,
  isLoggedIn: _propTypes.default.bool
};
var _default = MiniListing;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/MiniListing.js
// module id = 249
// module chunks = 0